import { useEffect, useState } from 'react';
import { doc, onSnapshot } from 'firebase/firestore';
import { db } from '../firebase/config';

// settings/platform.cardPaymentEnabled: kort er på til admin skrur det av (mangler feltet, er kort på).
export function useCardFeature() {
  const [enabled, setEnabled] = useState(true);
  const [loading, setLoading] = useState(true);

  useEffect(() => onSnapshot(
    doc(db, 'settings', 'platform'),
    snap => { setEnabled(snap.data()?.cardPaymentEnabled !== false); setLoading(false); },
    () => { setEnabled(true); setLoading(false); },
  ), []);

  return { enabled, loading };
}
